(function ($) {
	var pauseStickyCheck = false;

	stickyHeaderCheck();

    $(window).scroll(function () {
		stickyHeaderCheck();
    });

    // $('.main-menu-toggle').click(function(e) {
    //     forceSticky();
    // });

    function stickyHeaderCheck() {
    	if (pauseStickyCheck) return;

    	$('header').toggleClass('is-sticky', $(document).scrollTop() > 120);

        if ($(document).scrollTop() < 120) {
            $('.home .logo-link img').attr('src','/wp-content/themes/dioguard/assets/images/logo.svg');
        }

        if ($(document).scrollTop() > 120) {
            $('.logo-link img').attr('src','/wp-content/themes/dioguard/assets/images/logo-light.svg');
        }


        var mq = window.matchMedia( "(max-width: 980px)" );
        if (mq.matches) {
            if ($(document).scrollTop() > 120) {
                $('.modal-close .logo-link img').attr('src','/wp-content/themes/dioguard/assets/images/logo-light.svg');
                $('.modal-open .logo-link img').attr('src','/wp-content/themes/dioguard/assets/images/logo.svg');
            }
        }
        
    }

    // function forceSticky() {
    //     $('.logo-link img').attr('src','/wp-content/themes/dioguard/assets/images/logo.svg');

    //     pauseStickyCheck = true;

    //     window.setTimeout(function() {
    //         pauseStickyCheck = false;
    //     }, 850);
    // }

})(jQuery);